
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ModuleInfo } from "../types";
import { JwtAuthService } from "../services";
import { Token } from "marked";
import { TokenPermissions } from "@nt-portal/server-sdk";
import { decompressBase64 } from "../common";




export interface ModulesState {
    modules: ModuleInfo[]
    userModules: (string | undefined)[];
    loaded?: boolean;
    loadedModules: string[];
}

export const initModulesState: ModulesState = {
    modules: new Array<ModuleInfo>(),
    userModules: new Array<string>(),
    loadedModules: new Array<string>(),
    loaded: false
}

export const getUserModules = createAsyncThunk(
    'modules/getUserModules',
    async (arg, { getState }) => {
        let userToken = JwtAuthService.decodeToken();
        let permissions = decompressBase64(userToken?.permission ?? "") as TokenPermissions;

        let modules = Object.keys(permissions ?? {});
        let set = new Set<string>(modules)
        return Array.from(set)
    }
)





const ModulesSlice = createSlice({
    name: 'modules',
    initialState: initModulesState,
    reducers: {
        setModules(state, action) {
            if (state.modules.length === 0) {
                state.modules = action.payload;
            }
        },
        setUserModules(state, action) {
            state.userModules = action.payload;
        },
        setLoadedModule(state, action) {
            let modules = [...state.loadedModules]
            if (!modules.includes(action.payload)) {
                modules.push(action.payload)
            }
            state.loadedModules = modules;
        },

    },
    extraReducers: (builder) => {

        builder.addCase(getUserModules.pending, (state, action) => {

        })
        builder.addCase(getUserModules.fulfilled, (state, action) => {
            state.userModules = action.payload;
            state.loaded = true;
        })
        builder.addCase(getUserModules.rejected, (state, action) => {

            throw action.error;
        })
    }
});

export const { setModules, setUserModules, setLoadedModule } = ModulesSlice.actions;
export default ModulesSlice.reducer;